module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Vehicle Movement Tracking Utility")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  })], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.AllDetails.allModuleId ? _vm.AllDetails.allModuleId : '',
      "jobSeriesBanner": _vm.AllDetails.salesSeries ? _vm.AllDetails.salesSeries : '',
      "bannerClientName": _vm.AllDetails.clientName ? _vm.AllDetails.clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('div', [_c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('table', {
    staticClass: "table table-sm table-bordered table-striped table-responsive"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('b', [_vm._v("Ass.No:" + _vm._s(_vm.AllDetails.salesSeries))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Client:" + _vm._s(_vm.AllDetails.clientName))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("PICK:" + _vm._s(_vm.AllDetails.PICK))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Stuff:" + _vm._s(_vm.AllDetails.STUFF))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("HOV:" + _vm._s(_vm.AllDetails.HAND))])])])])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Disable Same for all")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "name": "some-radios",
      "value": "G"
    },
    model: {
      value: (_vm.selectedSame),
      callback: function($$v) {
        _vm.selectedSame = $$v
      },
      expression: "selectedSame"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-striped table-responsive"
  }, [_c('br'), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Vehicle No")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                      Dispatch date ( Departed from ICD)\n                      "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("Same for all")]), _vm._v(" "), _c('b-form-radio', {
    staticStyle: {
      "margin-top": "-22px !important",
      "margin-left": "82px !important"
    },
    attrs: {
      "name": "some-radios",
      "value": "A"
    },
    model: {
      value: (_vm.selectedSame),
      callback: function($$v) {
        _vm.selectedSame = $$v
      },
      expression: "selectedSame"
    }
  })], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                      Stuffing / De-stuffing Date\n                      "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("Same for all")]), _vm._v(" "), _c('b-form-radio', {
    staticStyle: {
      "margin-top": "-22px !important",
      "margin-left": "82px !important"
    },
    attrs: {
      "name": "some-radios",
      "value": "B"
    },
    model: {
      value: (_vm.selectedSame),
      callback: function($$v) {
        _vm.selectedSame = $$v
      },
      expression: "selectedSame"
    }
  })], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                      Arrival at Factory\n                      "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("Same for all")]), _vm._v(" "), _c('b-form-radio', {
    staticStyle: {
      "margin-top": "-22px !important",
      "margin-left": "82px !important"
    },
    attrs: {
      "name": "some-radios",
      "value": "C"
    },
    model: {
      value: (_vm.selectedSame),
      callback: function($$v) {
        _vm.selectedSame = $$v
      },
      expression: "selectedSame"
    }
  })], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                      Dispatch from Factory\n                      "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("Same for all")]), _vm._v(" "), _c('b-form-radio', {
    staticStyle: {
      "margin-top": "-22px !important",
      "margin-left": "82px !important"
    },
    attrs: {
      "name": "some-radios",
      "value": "D"
    },
    model: {
      value: (_vm.selectedSame),
      callback: function($$v) {
        _vm.selectedSame = $$v
      },
      expression: "selectedSame"
    }
  })], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                      Arrival at Port / ICD\n                      "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("Same for all")]), _vm._v(" "), _c('b-form-radio', {
    staticStyle: {
      "margin-top": "-22px !important",
      "margin-left": "82px !important"
    },
    attrs: {
      "name": "some-radios",
      "value": "E"
    },
    model: {
      value: (_vm.selectedSame),
      callback: function($$v) {
        _vm.selectedSame = $$v
      },
      expression: "selectedSame"
    }
  })], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                      Vehicle Release Date\n                      "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("Same for all")]), _vm._v(" "), _c('b-form-radio', {
    staticStyle: {
      "margin-top": "-22px !important",
      "margin-left": "82px !important"
    },
    attrs: {
      "name": "some-radios",
      "value": "F"
    },
    model: {
      value: (_vm.selectedSame),
      callback: function($$v) {
        _vm.selectedSame = $$v
      },
      expression: "selectedSame"
    }
  })], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("status")])]), _vm._v(" "), _vm._l((_vm.consoGRNMail), function(item, indx) {
    return _c('tr', {
      key: indx
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(indx + 1))]), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(item.vehicleNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerNo))]), _vm._v(" "), _c('td', [_c('date-picker', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "lang": "en",
        "value-type": "format",
        "format": "YYYY-MM-DD"
      },
      on: {
        "input": function($event) {
          _vm.renderSameForAll(item)
        }
      },
      model: {
        value: (item.vehicleDispatchDate),
        callback: function($$v) {
          _vm.$set(item, "vehicleDispatchDate", $$v)
        },
        expression: "item.vehicleDispatchDate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('date-picker', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "lang": "en",
        "value-type": "format",
        "format": "YYYY-MM-DD"
      },
      on: {
        "input": function($event) {
          _vm.renderSameForAll(item)
        }
      },
      model: {
        value: (item.vehicleStuffingDate),
        callback: function($$v) {
          _vm.$set(item, "vehicleStuffingDate", $$v)
        },
        expression: "item.vehicleStuffingDate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('date-picker', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "lang": "en",
        "value-type": "format",
        "format": "YYYY-MM-DD"
      },
      on: {
        "input": function($event) {
          _vm.renderSameForAll(item)
        }
      },
      model: {
        value: (item.vehicleFactoryAriveDate),
        callback: function($$v) {
          _vm.$set(item, "vehicleFactoryAriveDate", $$v)
        },
        expression: "item.vehicleFactoryAriveDate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('date-picker', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "lang": "en",
        "value-type": "format",
        "format": "YYYY-MM-DD"
      },
      on: {
        "input": function($event) {
          _vm.renderSameForAll(item)
        }
      },
      model: {
        value: (item.vehicleFactoryDispatchDate),
        callback: function($$v) {
          _vm.$set(item, "vehicleFactoryDispatchDate", $$v)
        },
        expression: "item.vehicleFactoryDispatchDate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('date-picker', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "lang": "en",
        "value-type": "format",
        "format": "YYYY-MM-DD"
      },
      on: {
        "input": function($event) {
          _vm.renderSameForAll(item)
        }
      },
      model: {
        value: (item.vehicleAriveAtPortDate),
        callback: function($$v) {
          _vm.$set(item, "vehicleAriveAtPortDate", $$v)
        },
        expression: "item.vehicleAriveAtPortDate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('date-picker', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "lang": "en",
        "value-type": "format",
        "format": "YYYY-MM-DD"
      },
      on: {
        "input": function($event) {
          _vm.renderSameForAll(item)
        }
      },
      model: {
        value: (item.vehicleReleaseDate),
        callback: function($$v) {
          _vm.$set(item, "vehicleReleaseDate", $$v)
        },
        expression: "item.vehicleReleaseDate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('md-checkbox', {
      staticClass: "md-primary",
      style: (("" + (item.vehicleReleaseDateAdded == 1
                            ? 'cursor: not-allowed;'
                            : !item.vehicleReleaseDate
                            ? 'cursor: not-allowed;'
                            : ''))),
      attrs: {
        "md-value": item.status,
        "name": "status",
        "id": "status",
        "disabled": item.vehicleReleaseDateAdded == 1 ?
          true :
          !item.vehicleReleaseDate ?
          true :
          false
      },
      model: {
        value: (item.status),
        callback: function($$v) {
          _vm.$set(item, "status", $$v)
        },
        expression: "item.status"
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }, [_c('b-button', {
    staticStyle: {
      "width": "100px",
      "margin-bottom": "10px"
    },
    attrs: {
      "disabled": _vm.emailModal.transportMailId == '' ? false : true,
      "id": "sendLoaderMain",
      "variant": "primary"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "sendLoader"
    }
  })], 1), _vm._v(" "), (
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ||
    _vm.$sessionsStorage.get('cust_username') == 'vikramsingh' ||
    _vm.$sessionsStorage.get('cust_username') == 'gouravmishra'
  ) ? _c('div', {
    staticClass: "table-striped table-responsive"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("GPS Fetch Transported Details")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('br'), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Vehicle No")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                        Dispatch Date ( Departed from ICD)(Pickup Out Time)\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Stuffing / De-stuffing Date(Factory IN Time)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Arrival at Factory(Factory IN Time)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dispatch from Factory(Factory Out Time)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Arrival at Port / ICD(Handover In Time)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Vehicle Release Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Status")])]), _vm._v(" "), _vm._l((_vm.consoGPSGRNMail), function(item, indx) {
    return _c('tr', {
      key: indx
    }, [_c('th', {
      style: (item.tptType == 1 ?
        '' :
        'background:#f28877;color:white;font-weight:bold'),
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                        " + _vm._s(indx + 1) + "\n                      ")]), _vm._v(" "), _c('th', {
      style: (item.tptType == 1 ?
        '' :
        'background:#f28877;color:white;font-weight:bold'),
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                        " + _vm._s(item.vehicleNo) + "\n                        "), _c('br'), _vm._v(" "), _c('span', [_vm._v("GRN Series : " + _vm._s(item.GRNSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("GRN Date : " + _vm._s(item.Date))]), _vm._v(" "), _c('span', [_vm._v("Type :\n                          " + _vm._s(item.tptType == 1 ? "Pridel" : "Outsourced"))])]), _vm._v(" "), _c('td', {
      style: (item.tptType == 1 ?
        '' :
        'background:#f28877;color:white;font-weight:bold')
    }, [_vm._v("\n                        " + _vm._s(item.containerNo) + "\n                      ")]), _vm._v(" "), _c('td', {
      style: (item.tptType == 1 ?
        '' :
        'background:#f28877;color:white;font-weight:bold')
    }, [_c('span', [_vm._v(_vm._s(_vm.getDateFormate(item.gps_vehicle_dispatch_date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_dispatch_date_loc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_dispatch_date_dist))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Lat : " + _vm._s(item.gps_vehicle_dispatch_date_lati))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Long : " + _vm._s(item.gps_vehicle_dispatch_date_longi))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('td', {
      style: (item.tptType == 1 ?
        '' :
        'background:#f28877;color:white;font-weight:bold')
    }, [_c('span', [_vm._v(_vm._s(_vm.getDateFormate(item.gps_vehicle_stuffing_date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_stuffing_date_loc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_stuffing_date_dist))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Lat : " + _vm._s(item.gps_vehicle_stuffing_date_lati))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Long : " + _vm._s(item.gps_vehicle_stuffing_date_longi))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('td', {
      style: (item.tptType == 1 ?
        '' :
        'background:#f28877;color:white;font-weight:bold')
    }, [_c('span', [_vm._v(_vm._s(_vm.getDateFormate(item.gps_vehicle_factory_arive_date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_factory_arivedate_loc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_factory_arive_date_dist))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Lat : " + _vm._s(item.gps_vehicle_factory_arive_date_lati))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Long : " + _vm._s(item.gps_vehicle_factory_arive_date_longi))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('td', {
      style: (item.tptType == 1 ?
        '' :
        'background:#f28877;color:white;font-weight:bold')
    }, [_c('span', [_vm._v(_vm._s(_vm.getDateFormate(item.gps_vehicle_factory_dispatch_date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_factory_dispatch_date_loc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_factory_dispatch_date_dist))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Lat : " + _vm._s(item.gps_vehicle_factory_dispatch_date_lati))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Long : " + _vm._s(item.gps_vehicle_factory_dispatch_date_longi))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('td', {
      style: (item.tptType == 1 ?
        '' :
        'background:#f28877;color:white;font-weight:bold')
    }, [_c('span', [_vm._v(_vm._s(_vm.getDateFormate(item.gps_vehicle_arive_at_port_date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_arive_at_port_date_loc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_arive_at_port_date_dist))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Lat : " + _vm._s(item.gps_vehicle_arive_at_port_date_lati))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Long : " + _vm._s(item.gps_vehicle_arive_at_port_date_longi))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('td', {
      style: (item.tptType == 1 ?
        '' :
        'background:#f28877;color:white;font-weight:bold')
    }, [_c('span', [_vm._v(_vm._s(_vm.getDateFormate(item.gps_vehicle_release_date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_release_date_loc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.gps_vehicle_release_date_dist))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Lat : " + _vm._s(item.gps_vehicle_release_date_lati))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Long : " + _vm._s(item.gps_vehicle_release_date_longi))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('td', {
      style: (item.tptType == 1 ?
        '' :
        'background:#f28877;color:white;font-weight:bold')
    }, [_c('span', [_vm._v(_vm._s(item.gps_vehicleReleaseDateAdded == 1 ?
      "Released" :
      "Not Released"))]), _vm._v(" "), _c('br')])])
  })], 2)])]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showMailDetails.length > 0) ? _c('div', {
    staticClass: "box-body mt-3"
  }, [_c('table', {
    staticClass: "table tableSecondry",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "id": "truckDetail2"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Event")]), _vm._v(" "), _c('th', [_vm._v("Vehicle No.")]), _vm._v(" "), _c('th', [_vm._v("Date & Time")]), _vm._v(" "), _c('th', [_vm._v("Updated By")]), _vm._v(" "), _c('th', [_vm._v("Current Location")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.showMailDetails), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.editMail(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.eventName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vehicleTruckId == 0 ? "----" : item.regdNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fromGps == "1" ? "GPS" : "SYSTEM"))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.showDirection(item.vehicleTruckId)
        }
      }
    }, [_c('md-icon', [_vm._v("pin_drop")])], 1)], 1)])
  }))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d094170","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/tranportMailDetails.vue
// module id = 2610
// module chunks = 0